module.exports = __webpack_public_path__ + "static/media/gutter_cleaning.08c8b2dd.png";